import { Box } from '@mui/material'
import React, { ReactNode } from 'react'
import { styles } from './styles'

export type RectangleProps = {
    padding?: number
    children: ReactNode
}

export const Rectangle = ({ padding = 2, children }: RectangleProps): React.ReactElement => {
    return (
        <Box p={padding} sx={styles.rectangle} flexWrap="wrap">
            {children}
        </Box>
    )
}
